/*
 * Copyright (c) 2020. Sayari LLC
 */


import {Special} from '../shared/models/special.model';
import {ZipcodeSearchService} from '../service/zipcodesearch.service';
import {Coordinates} from '../shared/models/coordinates.model';
import {Component, OnInit} from '@angular/core';
import {SpecialsService} from './specials.service';

@Component({
    selector: 'app-specials',
    templateUrl: './specials.component.html'
})
export class SpecialsComponent implements OnInit {
    page = 0;
    special: Special;
    specials: Special[];
    showLoadMoreButton: boolean;
    latitude: number;
    longitude: number;
    specialsNotFound: boolean;
    constructor(private specialsService: SpecialsService, private zipcodesearchService: ZipcodeSearchService) {
    }
    loadMore() {
        console.log('loading...');
        this.page = this.page + 1;
        console.log('page:' + this.page);
        this.specialsService.getSpecials(this.page, this.latitude, this.longitude).subscribe(data => {
            this.showLoadMoreButton = data.length === 10;
            for (const entry of data) {
                this.specials.push(entry);
            }
        });
    }
    ngOnInit(): void {
        this.zipcodesearchService.specialsObservable.subscribe((specials: Special[]) => {
            if (specials !== undefined) {
                this.specials = specials;
                console.log('specials==>' + specials);
                // todo this should come from server
                this.showLoadMoreButton = specials.length === 10;
                this.specialsNotFound = specials.length === 0;
                const jsonObj: any = JSON.parse(localStorage.getItem('coordinates'));
                const coordinates = <Coordinates>jsonObj;
                this.latitude = coordinates.y;
                this.longitude = coordinates.x;
                console.log('Received specials');
            }
        });
        const self = this;
        navigator.geolocation.getCurrentPosition(function(location) {
            self.latitude = location.coords.latitude;
            self.longitude = location.coords.longitude;
            self.specialsNotFound = self.latitude === undefined && self.longitude === undefined;
            self.specialsService.getSpecials(self.page, self.latitude, self.longitude).subscribe(data => {
                console.log('nav...page:' + self.page);
                // todo this should come from server
                self.showLoadMoreButton = data.length === 10;
                console.log('show load more:' + self.showLoadMoreButton);
                self.specialsNotFound = data.length === 0;
                self.specials = data;
            });
        }, function(error) {
            console.log('error:' + error.message);
            self.specialsNotFound = true;
        });
    }
}